var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.33203V13.9942C14 14.3654 13.7035 14.6654 13.3377 14.6654H2.66227C2.29663 14.6654 2 14.3694 2 14.0042V1.99323C2 1.63557 2.29913 1.33203 2.66814 1.33203H9.99787L14 5.33203ZM12.6667 5.9987H9.33333V2.66536H3.33333V13.332H12.6667V5.9987ZM5.33333 4.66536H7.33333V5.9987H5.33333V4.66536ZM5.33333 7.33203H10.6667V8.66536H5.33333V7.33203ZM5.33333 9.9987H10.6667V11.332H5.33333V9.9987Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetail);
export default __webpack_public_path__ + "static/media/icon_detail.6c7f429c1f6b7c7986f1937924091d12.svg";
export { ForwardRef as ReactComponent };